exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#confirmation-response[data-v-1b9fc7a8]{text-align:center}#confirmation-response .thanks[data-v-1b9fc7a8]{color:#588fc7;font-weight:400;margin:20px;margin-top:10px}#confirmation-response .info[data-v-1b9fc7a8]{margin:15px}#confirmation-response .stress[data-v-1b9fc7a8]{color:#ff4a12}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1b9fc7a8&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ConfirmationResponse.vue
// module id = 149
// module chunks = 0